import { CONFEAR_PERMISSIONS } from '@core/consts/CONFEAR-PERMISSIONS';
import { User } from '@core/models/entities/user/user';
import { AuthService } from '@core/services/auth/auth.service';
import { MenuService } from '@core/services/menu/menu.service';
import { ModalService } from '@core/services/modal/modal.service';
import { NotificationDropdownService } from '@core/services/notification-dropdown/notification-dropdown.service';
import { SystemService } from '@core/services/system/system.service';
import { MenuItem } from 'primeng/api';
import { TieredMenu } from 'primeng/tieredmenu';

import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  imports: [TieredMenu, RouterLink, CommonModule]
})
export class TopbarComponent implements OnInit {
  itemsUserMenu: MenuItem[] = [
    {
      id: '1',
      label: 'Alterar master',
      icon: 'pi pi-user',
      command: () => this.openModalSelectMaster()
    },
    {
      id: '2',
      label: 'Alterar Dados Cadastrais',
      icon: 'pi pi-user-edit',
      command: () => this.router.navigate(['alterar-dados-usuario'])
    },
    {
      id: '3',
      label: 'Alterar senha',
      icon: 'pi pi-lock-open',
      command: () => this.router.navigate(['alterar-senha-logado'])
    },
    {
      id: '4',
      label: 'Minhas Faturas',
      icon: 'pi pi-receipt',
      command: () => this.router.navigate(['faturas'])
    },
    {
      id: '5',
      label: 'Sair',
      icon: 'pi pi-sign-out',
      command: () => this.exit()
    }
  ];

  user: User;
  dropdownDisplay: boolean;
  menuDisplay: boolean;
  private MODAL_CHANGE_USER_MASTER = 'MODAL_CHANGE_USER_MASTER';
  masterLogged: any;
  env;
  logo: string;
  systemService = inject(SystemService);
  readonly MASTER = 1;
  readonly GESTOR = 2;
  items: MenuItem[];
  isCorporativo: boolean;

  constructor(
    private authService: AuthService,
    private notificationDropdownService: NotificationDropdownService,
    private menuService: MenuService,
    private modalService: ModalService,
    private router: Router
  ) {}

  async ngOnInit() {
    this.env = environment;
    this.getSystemConfig();
    await this.getUser();
    this.listenDisplayNotification();
    this.listenMenu();
  }

  getSystemConfig() {
    const conf = this.systemService.configuracao();
    this.logo = `assets/logos${conf?.imgLogoTopBar}`;
  }

  async getUser() {
    this.authService.getUserObservable().subscribe(response => {
      if (response) {
        this.items = this.itemsUserMenu;
        this.user = response;
        this.masterLogged = User.getLoggedMaster(this.user);
        this.isCorporativo = this.user.empresas.some(
          empresa => empresa.indCorporativo
        );
        if (!this.user?.indPossuiMultiplosMaster) {
          this.items = this.items.filter(item => item.id !== '1');
        }
        if (
          !(
            this.user.grupo[0]?.id === this.GESTOR ||
            this.user.grupo[0]?.id === this.MASTER
          ) ||
          this.isCorporativo
        ) {
          this.items = this.items.filter(item => String(item.id) !== '4');
        }
      }
    });
  }

  listenDisplayNotification() {
    this.notificationDropdownService.getDisplay().subscribe(display => {
      this.dropdownDisplay = display;
    });
  }

  listenMenu() {
    this.menuService
      .getDisplayMenuObservable()
      .subscribe((display: boolean) => {
        this.menuDisplay = display;
      });
  }

  toggleNotification() {
    this.notificationDropdownService[this.dropdownDisplay ? 'close' : 'open']();
  }

  toggleMenu() {
    this.menuService[this.menuDisplay ? 'close' : 'open']();
  }

  exit() {
    this.authService.logout().subscribe();
  }

  openModalSelectMaster() {
    if (this.user?.indPossuiMultiplosMaster) {
      this.modalService.open({
        id: CONFEAR_PERMISSIONS.TODOS,
        name: this.MODAL_CHANGE_USER_MASTER,
        open: true,
        data: null
      });
    }
  }
}
